var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idback",attrs:{"id":"idback"}},[_c('div',{staticClass:"issuer"},[_vm._v(_vm._s(_vm.issuer))]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.valied)+"-"+_vm._s(_vm.expire))])])
}
var staticRenderFns = []

export { render, staticRenderFns }